import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const NewMessageIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <g>
                    <path
                        d="M20.8,4.5V16h-9.2h-0.5l-0.4,0.4l-1.4,1.4v-0.6V16H8.1H3.2V4.5H20.8 M22,3.3H2v13.9h6.1v3.5l3.5-3.5H22V3.3
			L22,3.3z"
                    />
                </g>
            </g>
            <rect x="11.4" y="6.5" width="1.2" height="7.4" />
            <rect x="8.3" y="9.5" width="7.4" height="1.2" />
        </SvgIcon>
    );
};
